import store from '@/store/'
import route from '@/router/'
import axios from 'axios';
import * as _CONFIG from '@/config'
// import { email } from 'vuelidate/lib/validators';


// #
const param = {
    withCredentials: true,
}
//se for em modo producao nao adiciona o end point para a api de teste como base url 
//https://center.shoplist.net.br/api/v1/app/407
if (process.env.NODE_ENV !== 'production') {
    param.baseURL = process.env.VUE_APP_ROOT_API
} else {
    param.baseURL = window.location.origin
}
store.dispatch('setPublicKey',process.env.VUE_APP_PUBLIC_KEY)
//cria instancia de chamada http sem o display de busca 
//cria a instacia de http para ser utilizada no service
const http_sem_display = axios.create(param)

http_sem_display.defaults.headers.post['Content-Type'] = 'application/json';
http_sem_display.defaults.headers.put['Content-Type'] = 'application/json';

http_sem_display.interceptors.request.use(function (config) {
    return config
}, (err) => {
    return Promise.reject(err)
})
http_sem_display.interceptors.response.use((res) => {
    if (Object.prototype.hasOwnProperty.call(res, 'data')) {
        if (Object.prototype.hasOwnProperty.call(res.data, 'status')) {
            if (res.data.status == 20) {
                store.dispatch('setRedirect', { name: 'login' })
            }
        }
    }
    return res
}, (error) => {
    if (error.response) {
        store.dispatch('setMsgError', error.response)
        store.dispatch('setDisplayMsgErr', true)
    }
    return Promise.reject(error)
})




//cria a instacia de http para ser utilizada no service
const http = axios.create(param)

http.defaults.headers.post['Content-Type'] = 'application/json';
http.defaults.headers.put['Content-Type'] = 'application/json';

http.interceptors.request.use(function (config) {
    store.dispatch('displayLoading', true);
    return config
}, (err) => {
    store.dispatch('displayLoading', false);
    return Promise.reject(err)
})
http.interceptors.response.use((res) => {
    store.dispatch('displayLoading', false);
    if (Object.prototype.hasOwnProperty.call(res, 'data')) {
        if (Object.prototype.hasOwnProperty.call(res.data, 'status')) {
            if (res.data.status == 20) {
                store.dispatch('setRedirect', { name: 'login' })
            }
        }
    }
    return res
}, (error) => {
    store.dispatch('displayLoading', false);
    console.log(error)
    if (error.response) {
        store.dispatch('setMsgError', error.response)
        store.dispatch('setDisplayMsgErr', true)
    }
    return Promise.reject(error)
})
export function bgContainer () {
    return store.getters.isDark ? store.getters.bgContainerDark : store.getters.bgContainer
}
export function openSuporte(){
    window.open('https://suporte.alertme.com.br/');
}
export function openTelegram(){
    window.open('https://t.me/AlertemeBot');
}
export function getUrlTelegram(){
    return 'https://t.me/AlertemeBot'
}
export function getHostIdUrl (route) {
    if (Object.prototype.hasOwnProperty.call(route.params, 'hostId')) {
        return route.params.hostId
    }
    return null
}
export function responseExtractError (_) {
    let resposta = _.response.data.message
    if (_.response.data.data) {
        let content = _.response.data.data
        resposta = '';
        for (let value in content) {
            resposta += content[value].join('<br>');
            resposta += (content[value].length == 1) ? '<br>' : '';
        }
    }
    return resposta
}
export async function buscaCep (cep) {
    cep = cep.replace(/\D/g, '')
    const http = axios.create();
    return await http.get(`https://viacep.com.br/ws/${cep}/json/unicode/`)

}
export function localStoreHostUser (user, data) {
    let content = {}
    if (Object.prototype.hasOwnProperty.call(localStorage, 'host')) {
        content = JSON.parse(localStorage.getItem('host'))
    }
    let lista = {}
    if (Object.prototype.hasOwnProperty.call(content, user)) {
        lista = content[user]
    }
    data.forEach(ele => {
        let info = {
            mod: [],
            auth: false,
            perfil: {},
            config: {}
        }
        if (Object.prototype.hasOwnProperty.call(lista, ele.hostId)) {
            info = lista[ele.hostId]
        }
        info.descr = ele.descr
        info.hostId = ele.hostId
        //
        lista[ele.hostId] = info
    });
    content[user] = lista
    //
    localStorage.setItem('host', JSON.stringify(content))
}

export function getListHostUser (user) {
    let content = {}
    if (Object.prototype.hasOwnProperty.call(localStorage, 'host')) {
        content = JSON.parse(localStorage.getItem('host'))
    }
    if (Object.prototype.hasOwnProperty.call(content, user)) {
        return content[user]
    }
    return null
}
export function getInfoHostUser (user, hostId) {
    let content = {}
    if (Object.prototype.hasOwnProperty.call(localStorage, 'host')) {
        content = JSON.parse(localStorage.getItem('host'))
    }
    let lista = {}
    if (Object.prototype.hasOwnProperty.call(content, user)) {
        lista = content[user]
    }
    if (Object.prototype.hasOwnProperty.call(lista, hostId)) {
        return lista[hostId]
    }
    return null
}
export function checkMod(codigo){
    let host = getInfoHostUser(
        store.getters.getEmail,
        store.getters.hostActive
      );
      if (host == null || host.mod[0] == 999) {
    //   if (host == null) {
        return true;
      }
      return host.mod.includes(codigo);
}
export function setAuthHostUser (user, hostId, data) {
    let content = {}
    if (Object.prototype.hasOwnProperty.call(localStorage, 'host')) {
        content = JSON.parse(localStorage.getItem('host'))
    }
    let lista = {}
    if (Object.prototype.hasOwnProperty.call(content, user)) {
        lista = content[user]
    }
    if (Object.prototype.hasOwnProperty.call(lista, hostId)) {
        lista[hostId] = data
        content[user] = lista
        localStorage.setItem('host', JSON.stringify(content))
        return true
    }
    return false;
}
/**
 * end point da api
 */
//endpoint auth
export async function signIn (data) {
    return http.post(_CONFIG.URL_AUTH, data)
}
function isFunction (functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}
//endpoint para verificar se tem sessao ativa no servidor
export async function isActiveSession (hostId, callback) {
    // let query = getQueryProduto()
    let content = { hostId }
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_CHECK_SESSION, content).
        then((res) => {
            store.dispatch('displayLoading', false);
            //se existir status
            if (res.data.session == true) {
                store.commit('checkLogin')
                let email = localStorage.getItem(_CONFIG._USER_ACTIVE)
                let listHost = getListHostUser(email)
                if (listHost == null || listHost.length <= 0) {
                    listHost({ hostId: "", email: email })
                    .then(res => {
                      localStoreHostUser(email, res.data.value);
                      let redirect = store.getters.getRedirect
                      if(redirect!='' && Object.prototype.hasOwnProperty.call(redirect, 'name')) {
                        route.push(redirect)
                      }
                    })
                    .catch(e => {
                      if (e.response) {
                        this.$store.dispatch("setMsgError", e.response);
                        this.$store.dispatch("setDisplayMsgErr", true);
                        this.$store.dispatch("resetToken");
                      }
                    });
                    return false
                }
                let hosts = []
                Object.keys(listHost).forEach((key) =>{
                    hosts.push(listHost[key])
                })
                
                store.dispatch("setEmail", email);
                store.dispatch("setListHost", hosts);
                store.dispatch("setHostActive", hostId);
                //buscando perfil
                getPerfil({hostId }).then(
                    res => {
                        if (res.data.status) {
                            store.dispatch("setPerfil", {});
                        } else {
                            store.dispatch("setPerfil", res.data.value);
                        }
                    },
                    () => {
                        store.dispatch("setPerfil", {});
                    }
                );
                if (isFunction(callback)) {
                    callback(res.data)
                }
            }
            return res.data.session
        },
            (e) => {
                store.dispatch('displayLoading', false);
                console.log(e.response)
                return false
            })
}
//relaiza o logout da aplicacao
export function signOut (hostId,redirect=true) {
    logout(hostId).then(res => {
        if (res.data.status == 0) {
            store.dispatch('MsgSucces', res.data.msg)
            store.dispatch('displayMsgSuccess', true)
        }
        store.dispatch('resetToken')
        store.dispatch('setCams',[])
        if(redirect) {
            route.push({ name: 'login' }).catch(() => {});
        }
    },
        (e) => {
            if (e.response) {
                store.dispatch('setMsgError', e.response.data.msg)
                store.dispatch('setDisplayMsgErr', true)
            }
            store.dispatch('resetToken')
            if(redirect) {
                route.push({ name: 'login' }).catch(() => {});
            }
        })
}
export async function logout (hostId) {
    return await http.post(_CONFIG.URL_LOGOUT, { hostId })
}
export function refreshToken () {
    // http.post(_CONFIG.URL_AUTH_REFRESH, {})
    //     .then(res => {
    //         if (res.data.data.token.length > 0) {
    //             let token = res.data.data.token
    //             this.$store.dispatch('setToken', token)
    //         }
    //     },
    //         (e) => {
    //             this.$store.dispatch('setMsgError', e.response.data.message)
    //             this.$store.dispatch('setDisplayMsgErr', true)
    //             this.$store.dispatch('resetToken')
    //         })
}
export function isSignedIn () {
    const token = store.getters.getToken
    let localAuth = localStorage.getItem(_CONFIG._TOKEN_KEY);
    if (!token && (localAuth == null || localAuth == false)) {
        store.dispatch('setToken', false)
        return false
    }
    if (localAuth) {
        store.dispatch('setToken', true)
    }
    return true
}
//--------- inicio http sem load

//Salva informacao de troca de message
export async function sendMessageChannelNoLoad (data) {
    return await http_sem_display.post(_CONFIG.URL_INS_MSG, data);
}
//Busca message de retorno
export async function getMessageChannelNoLoad(data) {
    return await http_sem_display.post(_CONFIG.URL_MESSAGE_CHANEL, data);
}
//deleta message 
export async function deleteMessageChannelNoLoad (data) {
    return await http_sem_display.post(_CONFIG.URL_DEL_MSG, data);
}
//lista todas msg existentes 
export async function listMessageChannelNoLoad (data) {
    return await http_sem_display.post(_CONFIG.URL_MSG, data);
}
//--------- fim http sem load
//Salva informacao de troca de message
export async function sendMessageChannel (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_INS_MSG, data);
}
//Busca message de retorno
export async function getMessageChannel (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_MESSAGE_CHANEL, data);
}
//deleta message 
export async function deleteMessageChannel (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_DEL_MSG, data);
}
//lista todas msg existentes 
export async function listMessageChannel (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_MSG, data);
}
//busca as informacoes do hostID
export async function getInfoHostId (hostId) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_INFO_HOST, {hostId});
}
//busca os host do user
export async function listHost (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_LIST_HOST, data);
}
//endpoint para cadastra cliente
export async function createUser (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_CAD_USER, data);
}
//endpoint para atualizar nome da instancia
export async function updateLocal (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_UPD_HOST, data);
}
//endpoint para alterar senha
export async function changePassword (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_SAVE_PWD, data);
}
//endpoint para alterar senha
export async function resetPwd (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_RESET_PWD, data);
}
//endpoint retorna o perfil salvo
export async function getPerfil (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_PROFILE, data);
}
//endpoint para salvar o perfil
export async function setPerfil (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_SAVE_PROFILE, data);
}
//endpoint para salvar o perfil
export async function buscaCepVmtech (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_FIND_CEP, data);
}
//endpoint para salvar o perfil
export async function buscaPLanos (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_PLANS, data);
}
//endpoint para salvar o perfil
export async function checkout (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_CHECKOUT, data);
}
//endpoint para salvar o perfil
export async function cancelarAssinatura (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_CANCELAMENTO_PLANO, data);
}
//endpoint para salvar o perfil
export async function listUsuarios (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_USUARIOS, data);
}
//endpoint para salvar o perfil
export async function deleteUsuario (data) {
    store.dispatch('displayLoading', true);
    return await http.post(_CONFIG.URL_USUARIOS_DEL, data);
}


export function md5 (d) {
    let MD5 = function (d) { var r = M(V(Y(X(d), 8 * d.length))); return r.toLowerCase() }; function M (d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f } function X (d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ } function V (d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ } function Y (d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn (d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff (d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg (d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh (d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii (d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add (d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol (d, _) { return d << _ | d >>> 32 - _ }
    return MD5(d)
}